import { BrowserRouter as Router } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

export default function AppRouterProvider(props: Props) {
  return (
    <Router
      // Enable React Router v7 future flags to suppress deprecation warnings
      // These flags prepare the app for React Router v7 migration
      future={{
        // Use React's startTransition API for route transitions to improve performance
        // and suppress warnings about synchronous navigation updates
        v7_startTransition: true,
        // Enable v7's relative splat path behavior to suppress warnings about
        // absolute vs relative path handling in route definitions
        v7_relativeSplatPath: true,
      }}
    >
      {props.children}
    </Router>
  );
}
